$(function() {
    if($("#application_event_steering_rejects").length){
        $(".radio").click(check_application_steering_accepts);
        check_application_steering_accepts()
    }
});

function check_application_steering_accepts(){
    if ($("#application_event_steering_accepts")[0].checked == false && $("#application_event_steering_rejects")[0].checked == false) {
        $("#steering-accepts-next-submit").show()
        $("#steering-accepts-next-confirm").hide()
        $("div.application_comment").hide()
        $("label[for='application_steering_accepts_comment']").hide()
        $("label[for='application_steering_rejects_comment']").hide()
    } else {
        if ($("#application_event_steering_rejects")[0].checked == true) {
            $("#steering-accepts-next-submit").show()
            $("#steering-accepts-next-confirm").hide()
            $("div.application_comment").show()
            $("label[for='application_steering_accepts_comment']").hide()
            $("label[for='application_steering_rejects_comment']").show()
        } else {
            $("#steering-accepts-next-submit").hide()
            $("#steering-accepts-next-confirm").show()
            $("div.application_comment").show()
            $("label[for='application_steering_accepts_comment']").show()
            $("label[for='application_steering_rejects_comment']").hide()
        }
    }
}
